/**
 * @generated SignedSource<<30c8d874c23a5cbe3c36bd1d1337dd42>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RenameAICustomAppInput = {
  aiCustomAppID: number;
  name: string;
};
export type aiCustomAppsRenameMutation$variables = {
  input: RenameAICustomAppInput;
};
export type aiCustomAppsRenameMutation$data = {
  readonly renameAICustomApp: {
    readonly aiCustomAppID: number;
    readonly description: string | null;
    readonly isActive: boolean;
    readonly mediaFactoryAppID: number;
    readonly name: string;
  };
};
export type aiCustomAppsRenameMutation = {
  response: aiCustomAppsRenameMutation$data;
  variables: aiCustomAppsRenameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AICustomApp",
    "kind": "LinkedField",
    "name": "renameAICustomApp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiCustomAppID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mediaFactoryAppID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiCustomAppsRenameMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "aiCustomAppsRenameMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "7c57bc437f039a84eb9589bbe04f4939",
    "id": null,
    "metadata": {},
    "name": "aiCustomAppsRenameMutation",
    "operationKind": "mutation",
    "text": "mutation aiCustomAppsRenameMutation(\n  $input: RenameAICustomAppInput!\n) {\n  renameAICustomApp(input: $input) {\n    aiCustomAppID\n    name\n    description\n    mediaFactoryAppID\n    isActive\n  }\n}\n"
  }
};
})();

(node as any).hash = "d19388b14dd0e0e76b9facd5665a3bf4";

export default node;
